// extracted by css-extract-rspack-plugin
export default {"rating":"saAt8YYEjq8u7U_K","questionText":"MD3vHF72ohpDImsF","scale":"EfihnJd26L0sj2KJ","option":"BXN3T7ZasPAWF0V2","selected":"VCdNcPGsdRsESZPB","boundLabels":"aQMp0_ZpjA0mdC85"};